// extracted by mini-css-extract-plugin
module.exports = {"SocialIcons":"SocialIcons-SocialIcons-2ZV7Aa","SocialIcon":"SocialIcons-SocialIcon-1-ckTs"};